import { Router } from '@angular/router';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

import * as $ from 'jquery';
import { smoothlyMenu } from '../helpers';
// import 'jquery-slimscroll';
import { GlobalServices } from '../../services/global.service';
import { ssApiService } from 'app/services/ss-api.service';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
    selector: 'top-nav-bar',
    templateUrl: './topnavbar.component.html',
    styleUrls: ['./topnavbar.component.scss'],
    providers: [DialogService]
})
export class TopNavBarComponent implements OnInit, OnDestroy {
    @ViewChild('spLicenseKeysPanel') LicenseKeySuggestionsPanel: OverlayPanel;
    @ViewChild('spLicenseKeysTarget') LicenseKeySuggestionsTarget: HTMLElement;

    SearchInputClass: string = '';

    constructor(private dialogService: DialogService, private gb: GlobalServices, private router: Router, private api: ssApiService) {

    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    toggleNavigation(): void {
        $('body').toggleClass('mini-navbar');
        smoothlyMenu();

    }

    toggleRightSidebar(): void {
        $('#right-sidebar').toggleClass('sidebar-open');
    }

    isPossibleLicenseKeyChanged(event) {

    }

    onFocus(event: any): void {

        if (!$('#navBarContainer').hasClass('fullScreen')) {
            $('#navBarContainer').addClass('fullScreen');
            $('body').addClass('blurred');
            this.SearchInputClass = 'fullScreen';
        }

    }

    onClickSearchInput() {
        /*     var value = this.SearchInput.GetUnmaskedValue();
            if (value != null && value != "") */
        this.onFocus('');
    }


    closeSearch(resetInput: boolean = true): void {
        $('#navBarContainer').removeClass('fullScreen');
        $('body').removeClass('blurred');
        this.SearchInputClass = '';
    }

    SearchItemSelected() {
        this.closeSearch(false);
    }

    private GetLicenseKeyFormatted(raw: string): string {

        if (raw.length < 6 || raw.length > 16)
            return raw;

        else if (raw.length > 5 && raw.length < 11)
            return raw.substr(0, 5) + '-' + raw.substr(5);

        else if (raw.length > 10)
            return raw.substr(0, 5) + '-' + raw.substr(5, 5) + '-' + raw.substr(10);

    }

    private HideAllSuggestionPanels() {
        this.LicenseKeySuggestionsPanel.hide();
    }

    logout() {
        console.log("Lougout Clicked");

        this.dialogService.dialogComponentRefMap.forEach(dialog => {
            dialog.destroy();
        });
        let disposable = this.api.Logout(false).subscribe(
            response => {
                console.log('logout response', response);
                disposable.unsubscribe();
                this.gb.Logout();
                this.router.navigate(['/authentication/signin']);
                
            }, err => {
                disposable.unsubscribe();
                this.gb.Logout();
                this.router.navigate(['/authentication/signin']);
            });

    }

}
